(function(){
  'use strict';
  angular.module('irricrops')
  .controller("ntimelineCtrl", [ "$stateParams", '$timeout','$filter','$mdToast','volumenes','vinedo','estados',
  function( $stateParams, $timeout, $filter, $mdToast, volumenes, vinedo, estados){
    var vm            = this;
    vm.vinedoId       = $stateParams.id;
    vm.volumenes      = volumenes.data.data;
    vm.estados        = estados.data.data;
    vm.vinedo         = vinedo;
  }]);
})();
